import { ts } from '_core';

const defaultAlpha: ts.types.signal.RandomForestDraft = {
  dtype: 'randomForest',
  training_sample: {
    frequency: ts.enums.FREQUENCY_ENUM.WEEKLY,
    min_count: 1,
    number: 1,
  },
  return_horizon: {
    periods: { frequency: 'FREQUENCY', amount: 1 },
  },
  signals: [],
  n_estimators: 100,
  max_depth: null,
  training_frequency: ts.enums.FREQUENCY_ENUM.WEEKLY,
};

export default defaultAlpha;
